import React, { useEffect, useState, Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MENU_SLUG } from "../constants/constants";
import HeaderLayout from "./headerLayout";
import SidebarLayout from "./sidebarLayout";
import NdaDoc from "../components/ndaDoc";
import Payments from "../components/payments";
import { useAuth } from "../hooks/useAuth";

const Layout = ({ pages }) => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const isHeaderPath = [`/${MENU_SLUG.my_cars}`].includes(pathname);
  const isSidebarPath = !isHeaderPath;
  const [isPaymentAccepted, setIsPaymentAccepted] = useState(false);
  const [isNDAAccepted, setIsNDAAccepted] = useState(false);

  useEffect(() => {
    if (!auth.currentCar) {
      navigate(`/${MENU_SLUG.my_cars}`);
    } else {
      navigate(pathname === "/" ? `/${MENU_SLUG.snapshot}` : pathname);
    }
  }, [auth.currentCar, navigate, pathname]);

  useEffect(() => {
    setIsNDAAccepted(auth.ndaAccepted);
  }, [auth.ndaAccepted]);

  useEffect(() => {
    setIsPaymentAccepted(!auth.paymentWindow);
  }, [auth.paymentWindow]);

  if (!isNDAAccepted) {
    return <NdaDoc setIsNDAAccepted={setIsNDAAccepted} />;
  } else if (!isPaymentAccepted) {
    return (
      <Payments
        trialDays={auth.trialDays}
        membershipAmount={auth.membershipAmount}
      />
    );
  } else {
    return (
      <Fragment>
        {isHeaderPath && <HeaderLayout pages={pages} />}
        {isSidebarPath && <SidebarLayout pages={pages} />}
      </Fragment>
    );
  }
};

export default Layout;
